// ============================================================
//  Qbrix Analytics — GA4 + Meta Pixel unified tracker
//  Loaded on all pages after qbrix-wheel.js
// ============================================================

// Core tracking function — silent fail if GA/FB not loaded
function qbxTrack(eventName, params) {
  // GA4
  if (typeof gtag === 'function') {
    gtag('event', eventName, params || {});
  }
  // Meta Pixel — map to standard or custom events
  if (typeof fbq === 'function') {
    var fbEventMap = {
      'add_to_cart':           ['track', 'AddToCart'],
      'view_product':          ['track', 'ViewContent'],
      'wheel_lead':            ['track', 'Lead'],
      'hobby_preorder_submit': ['track', 'Lead'],
      'hobby_view':            ['track', 'ViewContent'],
      'hobby_collection_view': ['track', 'ViewContent'],
    };
    var mapped = fbEventMap[eventName];
    if (mapped) {
      // Standard Meta events: pass only recognised Meta fields to avoid web-pixel errors
      var metaAllowed = { value: 1, currency: 1, content_ids: 1, content_name: 1, content_type: 1, content_category: 1, num_items: 1, order_id: 1, predicted_ltv: 1, search_string: 1, status: 1 };
      var metaParams = {};
      if (params) { Object.keys(params).forEach(function(k) { if (metaAllowed[k]) metaParams[k] = params[k]; }); }
      fbq(mapped[0], mapped[1], metaParams);
    } else {
      // Custom event — snake_case → PascalCase
      var customName = eventName.split('_').map(function(w) {
        return w.charAt(0).toUpperCase() + w.slice(1);
      }).join('');
      fbq('trackCustom', customName, params || {});
    }
  }
}

// Expose globally (called from qbrix-product.js, qbrix-wheel.js)
window.qbxTrack = qbxTrack;

// ── All event listeners ──────────────────────────────────────

document.addEventListener('DOMContentLoaded', function() {

  // ── engaged_session: timestamps + page count ─────────────
  if (!sessionStorage.getItem('qbx_session_start')) {
    sessionStorage.setItem('qbx_session_start', Date.now());
  }
  var pages = parseInt(sessionStorage.getItem('qbx_page_count') || '0') + 1;
  sessionStorage.setItem('qbx_page_count', pages);

  function checkEngaged() {
    if (sessionStorage.getItem('qbx_engaged_fired')) return;
    var elapsed = Date.now() - parseInt(sessionStorage.getItem('qbx_session_start'));
    var pageCount = parseInt(sessionStorage.getItem('qbx_page_count') || '0');
    if (elapsed >= 300000 && pageCount >= 2) {
      sessionStorage.setItem('qbx_engaged_fired', '1');
      qbxTrack('engaged_session', { minutes: Math.floor(elapsed / 60000), pages: pageCount });
    }
  }
  setInterval(checkEngaged, 30000);
  window.addEventListener('beforeunload', checkEngaged);

  // ── view_product (product pages only) ────────────────────
  if (window.location.pathname.indexOf('/products/') === 0) {
    var atcBtn = document.getElementById('prod-atc-btn');
    if (atcBtn) {
      var productId = atcBtn.dataset.productId;
      var productTitle = atcBtn.dataset.productTitle;
      var price = parseInt(atcBtn.dataset.price, 10) / 100;
      var currency = atcBtn.dataset.currency || 'IDR';

      qbxTrack('view_product', {
        currency: currency,
        value: price,
        items: [{ item_id: productId, item_name: productTitle, price: price }],
        content_ids: [productId],
        content_name: productTitle,
        content_type: 'product'
      });

      // ── view_2_products ───────────────────────────────────
      var count = parseInt(sessionStorage.getItem('qbx_product_views') || '0') + 1;
      sessionStorage.setItem('qbx_product_views', count);
      if (count === 2) {
        qbxTrack('view_2_products', {});
      }
    }
  }

  // ── scroll_depth_75 ───────────────────────────────────────
  var _qbxScroll75Fired = false;
  window.addEventListener('scroll', function() {
    if (_qbxScroll75Fired) return;
    var scrolled = window.scrollY + window.innerHeight;
    var total = document.documentElement.scrollHeight;
    if (scrolled / total >= 0.75) {
      _qbxScroll75Fired = true;
      qbxTrack('scroll_depth_75', {
        page_type: document.body.className.match(/template-(\w+)/)?.[1] || 'unknown'
      });
    }
  }, { passive: true });

  // ── wa_click delegation ───────────────────────────────────
  document.addEventListener('click', function(e) {
    var link = e.target.closest('a[href*="wa.me"]');
    if (!link) return;
    var location = link.dataset.track || 'unknown';
    qbxTrack('wa_click', { location: location });
  });

  // ── marketplace_click delegation ──────────────────────────
  document.addEventListener('click', function(e) {
    var link = e.target.closest('.mp-link-btn, [data-track^="mp-"]');
    if (!link) return;
    var platform = 'unknown';
    var href = link.href || '';
    if (href.indexOf('shopee') !== -1) platform = 'shopee';
    else if (href.indexOf('tokopedia') !== -1) platform = 'tokopedia';
    else if (href.indexOf('tiktok') !== -1 || href.indexOf('go.qbrix') !== -1) platform = 'tiktok';
    qbxTrack('marketplace_click', { platform: platform });
  });

  // ── ATC form submit listener ──────────────────────────────
  var atcForm = document.getElementById('qbrix-product-form');
  if (atcForm) {
    atcForm.addEventListener('submit', function() {
      var btn = document.getElementById('prod-atc-btn');
      if (!btn) return;
      var qtyInput = document.getElementById('prod-qty');
      var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
      qbxTrack('add_to_cart', {
        currency: btn.dataset.currency || 'IDR',
        value: parseInt(btn.dataset.price, 10) / 100,
        items: [{
          item_id: btn.dataset.productId,
          item_name: btn.dataset.productTitle,
          price: parseInt(btn.dataset.price, 10) / 100,
          quantity: qty
        }],
        content_ids: [btn.dataset.productId],
        content_name: btn.dataset.productTitle
      });
    });
  }

});
